import * as React from 'react';
import { ArticleHeading2 } from '@cian/ui-kit';
import * as styles from './Section.css';

interface ISectionProps extends React.PropsWithChildren {
  'data-name'?: string;
  'data-testid'?: string;
  title?: string;
}

export const Section: React.FC<ISectionProps> = ({ children, title, ...props }) => {
  return (
    <section {...props}>
      {title && (
        <div className={styles['section-title']} data-testid="SectionHeader">
          <ArticleHeading2 as="h2">{title}</ArticleHeading2>
        </div>
      )}
      {children}
    </section>
  );
};
